module.exports = __webpack_public_path__ + "img/dog-login.333f684d.jpeg";